function initRawHomepage(root){
  root.querySelectorAll('.size-choice').forEach(function(select){
    if(select.dataset.initialized)return;
    select.dataset.initialized='true';
    function update(){
      var product=select.closest('.product');
      var chosen=select.options[select.selectedIndex];
      var link=product.querySelector('.meal-link');
      if(!select.disabled)link.href=select.dataset.productPath+'?variant='+encodeURIComponent(select.value);
      product.querySelector('.pack-note').hidden=!chosen||chosen.dataset.portionPack!=='true';
    }
    select.addEventListener('change',update); update();
  });
}
document.querySelectorAll('.ri-home').forEach(initRawHomepage);
document.addEventListener('shopify:section:load',function(event){event.target.querySelectorAll('.ri-home').forEach(initRawHomepage);});